import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { JournalEntry, JournalEntryCreate, JournalEntryFilter } from '../data/journalEntry';

export function createJournalEntryService(client: AxiosInstance) {
  return createCrudService<JournalEntry, JournalEntryCreate, JournalEntryFilter>(client, "/accounting/JournalEntry", "journalEntryId");
}

export type JournalEntryService = CrudService<JournalEntry, JournalEntryCreate, JournalEntryFilter>;
